/* eslint-disable no-unused-expressions */
import { API, graphqlOperation } from 'aws-amplify';
import { call, put } from 'redux-saga/effects';
import { getIOTDocument } from '../../../graphql/iot-documents';
import { fetchAllParksCustomer } from '../../../services/api';
import { classifyEquipmentType } from '../../../utils';
import { store } from '../..';

// const abreConexao = async (thing) => {
//   const newConection = await API.graphql(
//     graphqlOperation(onUpdateIOT, { thingName: thing.thing })
//   ).subscribe({
//     next: (subscribeData) => {
//       if (
//         subscribeData.value &&
//         subscribeData.value.data &&
//         subscribeData.value.data.onUpdateIOT
//       ) {
// let valorAtual = {};
// const { uchas, ebas } = store.getState().segundoNivel;
// let total = { ...uchas, ...ebas };
// const total = {
//   onTime: subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
//   potencia: subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
//   vazao: subscribeData.value.data.onUpdateIOT.Vazao,
// };
// if (thing.type.id === '1') {
//   total = {
//     ...total,
//     onTime:
//       uchas.onTime -
//       (valorAtual.onTime || 0) +
//       subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
//     vazaoUchas:
//       uchas.vazao -
//       (valorAtual.vazao || 0) +
//       subscribeData.value.data.onUpdateIOT.Vazao,
//   };
//   valorAtual = {
//     ...valorAtual,
//     onTime: subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
//   };
// } else {
//   total = {
//     ...total,
//     potencia:
//       ebas.potencia -
//       (valorAtual.potencia || 0) +
//       subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
//     vazaoEbas:
//       ebas.vazao -
//       (valorAtual.vazao || 0) +
//       subscribeData.value.data.onUpdateIOT.Vazao,
//   };
// }
// store.dispatch({
//   type: 'SEGUNDO/SET_VALORES_UCHAS_EBAS',
//   uchas: { onTime: total.onTime},
//   ebas: { potencia: total.potencia, vazao: total.vazao },
// });
// valorAtual = {
//   ...valorAtual,
//   potencia: subscribeData.value.data.onUpdateIOT.PotenciaAtivaMedia,
// };
//       }
//     },
//     error: () => {
//       newConection.unsubscribe();
//     },
//   });
//   return newConection;
// };

export async function conectaAplicacoesSegundoNivel({ parques }) {
  const things = parques
    .map(({ appliance }) =>
      appliance ? appliance.map(({ thing }) => thing) : []
    )
    .flat(3);

  const conexoesAbertas = store.getState().segundoNivel.conexoes;
  conexoesAbertas.forEach((ƒ) => ƒ());

  const total = { onTime: 0, vazaoEba: 0, vazaoUcha: 0, potencia: 0 };
  const iotQuery = await getIOTDocument();

  const values = await Promise.all(
    things.map(async (thing) => {
      try {
        const resp = await API.graphql(
          graphqlOperation(iotQuery, { thingName: thing.thing })
        );
        const data = 'getIOT' in resp ? resp.getIOT || {} : resp.data.getIOT;
        return { data, thing };
      } catch (error) {
        return { data: {}, thing };
      }
    })
  );

  values.forEach(({ data, thing }) => {
    // classifyEquipmentType normaliza 'tga'/'ucha' e 'bomba'/'eba'
    // (case-insensitive). Antes so casava '=== tga'/'=== bomba' e
    // descartava o resto, batendo o AGORA errado num parque misto.
    const categoria = classifyEquipmentType(thing.type);
    if (categoria === 'ucha') {
      total.onTime += data?.PotenciaAtivaMedia || 0;
      total.vazaoUcha += data?.Vazao || 0;
    } else if (categoria === 'eba') {
      total.vazaoEba += data?.Vazao || 0;
      total.potencia += data?.PotenciaAtivaMedia || 0;
    }
  });

  store.dispatch({
    type: 'SEGUNDO/SET_VALORES_UCHAS_EBAS',
    uchas: { onTime: total.onTime, vazao: total.vazaoUcha },
    ebas: { potencia: total.potencia, vazao: total.vazaoEba },
  });

  // NAO re-dispatcha SET_PARQUES aqui. Este saga recebe um conjunto
  // ESCOPADO de parques (ex.: so o parque selecionado, pra calcular o
  // AGORA), e antes reescrevia mapa.parques com esse subconjunto +
  // isOn (Sta_Rodando) — colapsando o mapa/lista pro parque selecionado.
  // O isOn nao e mais consumido (o card usa getStatus do status agregado),
  // entao o re-dispatch virou dead code que so causava o bug. mapa.parques
  // fica sob responsabilidade exclusiva do buscaZonasCliente (lista
  // completa do cliente).
}

export function* buscaZonasCliente({ customerId }) {
  const response = yield call(fetchAllParksCustomer, customerId);
  if (response.data && response.data.length) {
    yield put({
      type: 'SEGUNDO/SET_PARQUES',
      parques: response.data,
    });
  }
}
